interface NamedProfile {
  name?: string;
}

export function normalizeProfiles<T extends NamedProfile>(profiles?: T[] | null) {
  return Array.isArray(profiles) ? profiles : [];
}

export function formatProfileNames<T extends NamedProfile>(profiles: T[]) {
  return profiles
    .map((profile) => profile.name?.trim())
    .filter(Boolean)
    .join(', ');
}
